import router from "../router";
import i18n from "@/i18n";
import Messengers from "@/components/Icons/Messengers.vue"
import PhoneVibration from "@/components/Icons/PhoneVibration.vue";

const NAV_TYPE = {
    PAGE: 'page',
    MODAL: 'modal',
    URL: 'url',
}

function findPath(items, targetId) {
    for (const it of items) {
        if (it.key === targetId) {
            return [it.key]
        }
        if (it.children) {
            const sub = findPath(it.children, targetId)
            if (sub.length) {
                return [it.key, ...sub]
            }
        }
    }
    return []
}

const defaultState = () => {
    return {
        menu: [
            {
                key: "messengers",
                svg: Messengers,
                type: NAV_TYPE.PAGE,
                name: "Integration",
            },
            {
                key: 'telephony',
                svg: PhoneVibration,
                type: NAV_TYPE.PAGE,
                name: "TelephonySettings",
                ribbon: "New",
                ribbonColor: "rgb(115, 96, 242)",
                children: [
                    {
                        key: "settings",
                        type: NAV_TYPE.PAGE,
                        name: "TelephonySettings",
                    },
                    {
                        key: "statistics",
                        type: NAV_TYPE.PAGE,
                        name: "TelephonyStatistics",
                    },
                ]
            },
            {
                key: "tariff",
                icon: "tariff",
                type: NAV_TYPE.PAGE,
                name: "Tariffs",
                children: [
                    {
                        key: "payment",
                        type: NAV_TYPE.PAGE,
                        name: "Tariffs",
                        query: {tab: "payment"}
                    },
                    {
                        key: "calculator",
                        type: NAV_TYPE.PAGE,
                        name: "Tariffs",
                        query: {tab: "calculator"}
                    },
                    {
                        key: "activate_avance",
                        type: NAV_TYPE.PAGE,
                        name: "AdvanceActivation"
                    },
                    {
                        key: "subscription",
                        type: NAV_TYPE.PAGE,
                        name: "Subscription"
                    }
                ]
            },
            {
                key: "support",
                icon: "help",
                type: NAV_TYPE.MODAL,
                name: "HelpDialog",
            },
            {
                key: "knowledge_base",
                icon: "books",
                type: NAV_TYPE.URL,
                name: "https://help.e-chat.tech/",
            },
            {
                key: "api",
                icon: "bi-code-slash",
                type: NAV_TYPE.PAGE,
                name: "API",
            },
        ],
        activeKeys: JSON.parse(localStorage.getItem('activeKeys')) || []
    }
}

const navBarModule = {
    namespaced: true,
    state: defaultState(),
    getters: {
        navBarMenu: (s, _getters, _rootState, rootGetters) => rootGetters['auth/hasEarlyAccess']
            ? s.menu
            : s.menu.filter(m => m.key !== 'telephony'),
        activeKeys: s => s.activeKeys
    },
    mutations: {
        SET_ACTIVE_KEYS(state, ids) {
            state.activeKeys = ids
            localStorage.setItem('activeKeys', JSON.stringify(ids))
        }
    },
    actions: {
        setActiveKeys({commit, state}, item) {
            const path = Object.hasOwn(item, "children")
                ? findPath(state.menu, item.children[0].key)
                : findPath(state.menu, item.key)

            commit('SET_ACTIVE_KEYS', path)
        },
        async selectItem({commit, state, dispatch}, item) {
            if (item.type === NAV_TYPE.PAGE) {
                dispatch('setActiveKeys', item)
            }

            switch (item.type) {
                case NAV_TYPE.PAGE:
                    return router.push({
                        name: item.name,
                        query: item?.query ? item.query : undefined
                    })
                case NAV_TYPE.MODAL:
                    commit("setDialog", item.name, {root: true})
                    commit("openDialog", {}, {root: true})
                    return;
                case NAV_TYPE.URL:
                    const locale = i18n.global.locale.value
                    const lang = locale === 'ua' ? 'uk' : locale
                    window.open(item.name + lang, "_blank")
            }
        }
    }
}

export default navBarModule
